import React, { FC, useContext } from 'react'
import { Button } from 'antd'
import { LayoutRowWithActions } from '../../../../../../../components/data-control-row/layout-row-with-actions'
import { BlueConicConfigurationDispatchContext } from '../../configuration/reducer'
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons'
import { BlueConicFilterBuilder } from './blueconic-filter-builder'
import { Filter, FilterMap } from '../types'
import { BlueConicFilterType, FilterType } from '../enums'
import { MAX_META_FILTERS_VALUE } from '../../constants'
import '../styles/blueconic-filters-editor.scss'

import { BlueConicConfigurationContext } from '../../configuration/context'
import { EditableViewContext } from '@pushly/aqe/lib/components/hoc/editable-view/editable-view-context'

type BlueConicMetaFiltersEditorProps = {
    configId: string
    useStackedActionsPlacement?: boolean
} & (IncludedEditorProps | ExcludedEditorProps)

type IncludedEditorProps = {
    filterType: 'included'
    filters: FilterMap
}

type ExcludedEditorProps = {
    filterType: 'excluded'
    filters: FilterMap
}

export const BlueConicMetaFiltersEditor: FC<BlueConicMetaFiltersEditorProps> = ({ filterType, filters }) => {
    const ctxView = useContext(EditableViewContext)
    const isReadonly = ctxView.mode === 'view'
    const dispatch = useContext(BlueConicConfigurationDispatchContext)

    const handleFilterChange = (rowKey: string) => (filter: Filter) => {
        dispatch({ type: 'update-filter', filterType, filterKey: rowKey, filter })
    }

    return (
        <div className="blueconic-filters-editor">
            {Array.from(filters.entries()).map(([rowKey, filter], idx) => {
                return (
                    <LayoutRowWithActions
                        key={`filter-row-${filterType}_${rowKey}`}
                        readonly={isReadonly}
                        dataItem={
                            <BlueConicFilterBuilder
                                isFirst={idx === 0}
                                key={`filter-row-item-${filterType}_${rowKey}`}
                                filter={filter}
                                onChange={(value: Filter) => handleFilterChange(rowKey)(value)}
                            />
                        }
                        onCopy={() => {
                            if (filters.size >= MAX_META_FILTERS_VALUE) {
                                return
                            }
                            dispatch({
                                type: 'add-filter',
                                filterType,
                                filter,
                            })
                        }}
                        onDelete={() =>
                            dispatch({
                                type: 'remove-filter',
                                filterKey: rowKey,
                                filterType,
                            })
                        }
                    />
                )
            })}

            {!isReadonly && (
                <Button
                    type="primary"
                    size="small"
                    style={{ width: '30px', strokeWidth: '2' }}
                    icon={<PlusCircleFilled />}
                    disabled={filters.size >= MAX_META_FILTERS_VALUE}
                    onClick={() => {
                        if (filters.size >= MAX_META_FILTERS_VALUE) {
                            return
                        }
                        dispatch({
                            type: 'add-filter',
                            filterType,
                            filter: {
                                blueConicType: BlueConicFilterType.SITENAME,
                                filterType: FilterType.MATCHES_ANY_OF,
                            },
                        })
                    }}
                />
            )}
        </div>
    )
}
